import React, {Component} from 'react';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import MapContainer from '../../containers/init-map.js';

class GisClient extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: 'layer-1'
    }
  }

  componentDidUpdate() {
    document.querySelector('input[name=layers]:checked').value;
  }

  render() {
    var userData = JSON.parse(localStorage.getItem("userData"));
    return (
      <div>
        <SidebarMenuRouters profile="/profile-client/place/" place={this.props.match.params.vp}/>
        <Header userName={userData.name}/>
        <div className="content-maps">
          <div className="data-maps">
            <MapContainer idBusinessUnit={userData.idBusinessUnit}/>
          </div>
        </div>
      </div>
    );
  }

}

export default GisClient;

/*
*    /** <div className="tools-map">
            <div className="action-tool"><input type='checkbox' id='layer-1' name='layers' value='layer-1'
                                                checked={this.state.selected === 'layer-1'}
                                                onChange={(e) => this.setState({selected: e.target.value})}/><span>DISTRITO ELECTORAL</span>
            </div>
            <div className="action-tool"><input type='checkbox' id='layer-2'
                                                name='layers'
                                                value='layer-2'
                                                checked={this.state.selected === 'layer-2'}
                                                onChange={(e) => this.setState({selected: e.target.value})}/><span>PADRÓN CATASTRAL</span>
            </div>
          </div>*/



// WEBPACK FOOTER //
// ./src/scene/client/gis.js